import React, { useEffect, useRef, useCallback } from "react"
import { useLocation } from "react-router-dom"
import PropTypes from "prop-types"
import SimpleBar from "simplebar-react"
import MetisMenu from "metismenujs"
import withRouter from "components/Common/withRouter"
import { Link } from "react-router-dom"
import { withTranslation } from "react-i18next"
import Cookies from "js-cookie"

const SidebarContent = props => {
  const ref = useRef()
  const activateParentDropdown = useCallback(item => {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }, [])

  const removeActivation = items => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i]
      const parent = items[i].parentElement

      if (item && item.classList.contains("active")) {
        item.classList.remove("active")
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show")
        }

        parent.classList.remove("mm-active")
        const parent2 = parent.parentElement

        if (parent2) {
          parent2.classList.remove("mm-show")

          const parent3 = parent2.parentElement
          if (parent3) {
            parent3.classList.remove("mm-active") // li
            parent3.childNodes[0].classList.remove("mm-active")

            const parent4 = parent3.parentElement // ul
            if (parent4) {
              parent4.classList.remove("mm-show") // ul
              const parent5 = parent4.parentElement
              if (parent5) {
                parent5.classList.remove("mm-show") // li
                parent5.childNodes[0].classList.remove("mm-active") // a tag
              }
            }
          }
        }
      }
    }
  }

  const path = useLocation()
  const activeMenu = useCallback(() => {
    const pathName = path.pathname
    let matchingMenuItem = null
    const ul = document.getElementById("side-menu")
    const items = ul.getElementsByTagName("a")
    removeActivation(items)

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  }, [path.pathname, activateParentDropdown])

  useEffect(() => {
    ref.current.recalculate()
  }, [])

  useEffect(() => {
    new MetisMenu("#side-menu")
    activeMenu()
  }, [])

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
    activeMenu()
  }, [activeMenu])

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          {!JSON.parse(Cookies.get("authUser")).superAdmin ? 
            JSON.parse(Cookies.get("authUser")).orgRole === "admin" ? (
              <ul className="metismenu list-unstyled" id="side-menu">
                <li className="menu-title">{props.t("Цэс")} </li>

                <li>
                  <Link to="/dashboard">
                    <i className="bx bx-home-circle"></i>
                    <span>{props.t("Хяналтын самбар")}</span>
                  </Link>
                </li>

                <li className="menu-title">Диплом</li>
                <li>
                  <Link to="/add-diploma-batch">
                    <i className="bx bxs-add-to-queue"></i>
                    <span>{props.t("Багцаар нэмэх")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/diploma-list">
                    <i className="fas fa-clipboard-list"></i>
                    <span>{props.t("Дипломын жагсаалт")}</span>
                  </Link>
                </li>

                <li className="menu-title">Гэрчилгээ</li>
                <li>
                  <Link to="/certificate-list">
                    <i className="fas fa-clipboard-list"></i>
                    <span>{props.t("Гэрчилгээний жагсаалт")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/organization-signer-list">
                    <i className="mdi mdi-account-group"></i>
                    <span>{props.t("Гарын үсэг зурагчид")}</span>
                  </Link>
                </li>
                {/* <li>
                  <Link to="/group-list">
                    <i className="dripicons-photo-group"></i>
                    <span>{props.t("Групп")}</span>
                  </Link>
                </li> */}
                <li>
                  <Link to="/certificate-issues">
                    <i className="dripicons-photo-group"></i>
                    <span>{props.t("Сертификат")}</span>
                  </Link>
                </li>

                <li className="menu-title">Тохиргоо</li>
                <li>
                  <Link to="/change-credentials">
                    <i className="bx bxs-user-detail"></i>
                    <span>{props.t("Мэдээлэл шинэчлэх")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/change-password">
                    <i className="bx bx-cog"></i>
                    <span>{props.t("Нууц үг солих")}</span>
                  </Link>
                </li>
              </ul>
            ) : (
              <ul className="metismenu list-unstyled" id="side-menu">
                <li className="menu-title">{props.t("Цэс")} </li>
                <li>
                  <Link to="/dashboard">
                    <i className="bx bx-home-circle"></i>
                    <span>{props.t("Хяналтын самбар")}</span>
                  </Link>
                </li>

                <li className="menu-title">Гэрчилгээ</li>
                <li>
                  <Link to="/certificate-list">
                    <i className="fas fa-clipboard-list"></i>
                    <span>{props.t("Гэрчилгээний жагсаалт")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/signers-settings">
                    <i className="mdi mdi-account-group"></i>
                    <span>{props.t("Тохиргоо")}</span>
                  </Link>
                </li>
              </ul>
            )
           : (
            <ul className="metismenu list-unstyled" id="side-menu">
              <li className="menu-title">{props.t("Цэс")} </li>
              <li>
                <Link to="/admin-dashboard">
                  <i className="bx bx-home"></i>
                  <span>{props.t("Хяналтын самбар")}</span>
                </Link>
              </li>

              <li className="menu-title">Байгууллага</li>
              <li>
                <Link to="/organizations-list">
                  <i className="bx bx-building-house"></i>
                  <span>{props.t("Байгууллагын жагсаалт")}</span>
                </Link>
              </li>
              <li>
                <Link to="/credit-log">
                  <i className="bx bx-transfer-alt"></i>
                  <span>{props.t("Кредит гүйлгээ")}</span>
                </Link>
              </li>

              <li className="menu-title">Диплом</li>
              <li>
                <Link to="/all-diploma-list">
                  <i className="fas fa-clipboard-list"></i>
                  <span>{props.t("Бүх дипломын жагсаалт")}</span>
                </Link>
              </li>
              <li>
                <Link to="/certificate-issues">
                  <i className="bx bxs-file-find"></i>
                  <span>{props.t("Гэрчилгээний асуудлууд")}</span>
                </Link>
              </li>
            </ul>
          )}
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
